import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import { capitalize } from 'lodash';

const { Paragraph, Text, Title } = Typography;

const Addresses = ({ addresses, store_name }) => {
  const {
    address,
    city,
    province,
    recipient,
    second_line_address,
    zip_code,
  } = addresses;

  return (
    <Col span={24} className="section-container pd-reseller-detail-address">
      <div className=" inner-section">
        <Row className="summaryContent">
          <Col span={24}>
            <Title className="pageSubtitle" level={3}>
              Address
            </Title>
          </Col>
          <Col span={11}>
            <Card>
              <Text strong>{`${store_name} - ${capitalize(recipient)}`}</Text>
              <Paragraph className="pd-margin-top-sm">
                {`${address} ${second_line_address} ${city}, ${province} ${zip_code}`}
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default Addresses;
